module.exports = __webpack_public_path__ + "static/media/xleg_severe_right.f4c9390d.png";